import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarPlus, Loader2, X } from "lucide-react";
import { addPlanItem, delPlanItem, errText, fetchMySalons } from "@/lib/bf";

let cache = null;

export const BFPlanDel = ({ x, onDone }) => (
  <button type="button" className="bf-plan-del" title="Șterge programarea" onClick={(e) => { e.preventDefault(); delPlanItem(x.item).then(onDone).catch((er) => toast.error(errText(er, "Nu am putut șterge"))); }} data-testid={`bf-plan-del-${x.item}`}><X size={11} /></button>
);

export default function BFPlanAdd({ day, onDone }) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(cache);
  const [f, setF] = useState({ lead: "", time: "", note: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open && !list) fetchMySalons().then((r) => { cache = r; setList(r); }).catch(() => setList([])); }, [open, list]);
  const save = (e) => {
    e.preventDefault();
    if (!f.lead) return toast.error("Alege salonul");
    setBusy(true);
    addPlanItem({ ...f, date: day }).then(() => { toast.success("Vizită programată"); setF({ lead: "", time: "", note: "" }); setOpen(false); onDone(); })
      .catch((er) => toast.error(errText(er, "Nu am putut programa"))).finally(() => setBusy(false));
  };
  if (!open) return <button type="button" className="bf-plan-add-btn" onClick={() => setOpen(true)} data-testid={`bf-plan-add-${day}`}><CalendarPlus size={13} /> Programează</button>;
  return (
    <form className="bf-plan-add" onSubmit={save} data-testid={`bf-plan-add-form-${day}`}>
      {!list ? <Loader2 size={14} className="animate-spin" /> : (
        <select value={f.lead} onChange={(e) => setF({ ...f, lead: e.target.value })} data-testid="bf-plan-add-salon">
          <option value="">Alege salonul…</option>
          {list.map((x) => <option key={x.id} value={x.id}>{x.salon}{x.city ? ` · ${x.city}` : ""}</option>)}
        </select>
      )}
      <input type="time" value={f.time} onChange={(e) => setF({ ...f, time: e.target.value })} data-testid="bf-plan-add-time" />
      <input value={f.note} maxLength={200} placeholder="Notă (opțional)" onChange={(e) => setF({ ...f, note: e.target.value })} data-testid="bf-plan-add-note" />
      <button type="submit" className="st-btn st-btn--silver" disabled={busy} data-testid="bf-plan-add-save">{busy ? <Loader2 size={14} className="animate-spin" /> : <CalendarPlus size={14} />} Salvează</button>
      <button type="button" className="st-btn st-btn--ghost" onClick={() => setOpen(false)} data-testid="bf-plan-add-cancel"><X size={14} /></button>
    </form>
  );
}
